import { render, staticRenderFns } from "./jt808-devices.vue?vue&type=template&id=524bf77a&scoped=true&"
import script from "./jt808-devices.vue?vue&type=script&lang=js&"
export * from "./jt808-devices.vue?vue&type=script&lang=js&"
import style0 from "./jt808-devices.vue?vue&type=style&index=0&id=524bf77a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524bf77a",
  null
  
)

export default component.exports